// source: krafty_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var plant_pb = require('./plant_pb.js');
goog.object.extend(proto, plant_pb);
var upstream_pb = require('./upstream_pb.js');
goog.object.extend(proto, upstream_pb);
var device_pb = require('./device_pb.js');
goog.object.extend(proto, device_pb);
var template_pb = require('./template_pb.js');
goog.object.extend(proto, template_pb);
var image_pb = require('./image_pb.js');
goog.object.extend(proto, image_pb);
var worker_pb = require('./worker_pb.js');
goog.object.extend(proto, worker_pb);
var agent_state_pb = require('./agent_state_pb.js');
goog.object.extend(proto, agent_state_pb);
var user_pb = require('./user_pb.js');
goog.object.extend(proto, user_pb);
